import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { genericError } from '@/utils/alerts.service';
import { detail } from './detail';

export const ourPublicProfiles = {
  namespaced: true,
  state: {
    profiles: [],
    query: '',
    activeProfile: '',
    currentPage: 1,
    count: 0,
    pageSize: 48,
    timeout: null,
    loading: false,
    isVendor: false,
  },
  getters: {
    profiles(state) {
      let profiles = state.profiles;

      profiles.sort((a, b) => {
        const first = a.agencyName || a.directoryVendorName;
        const second = b.agencyName || b.directoryVendorName;
        return first.localeCompare(second, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });

      return profiles;
    },

    activeProfile(state) {
      return state.activeProfile;
    },
  },
  mutations: {
    setProfiles(state, data) {
      state.profiles = data;
    },

    setCount(state, count) {
      state.count = count;
    },

    setSearchQuery(state, query) {
      state.query = query;
    },

    setLoading(state, bool) {
      state.loading = bool;
    },

    setCurrentPage(state, page) {
      state.currentPage = page;
    },

    setActiveProfile(state, name) {
      state.activeProfile = name;
    },

    setQuery(state, query) {
      state.query = query;
    },

    setIsVendor(state, bool) {
      state.isVendor = bool;
    },
  },
  actions: {
    resetQuery({ dispatch, commit }) {
      commit('setQuery', '');
      dispatch('fetchPublicProfiles', 1);
    },
    async fetchPublicProfiles({ dispatch, commit, state }, page = 1) {
      commit('setLoading', true);
      return vendorDashboardAPI
        .getPublicProfiles(page, state.pageSize, state.query)
        .then(data => {
          commit('setCount', data.count);
          commit('setProfiles', data.results);
          commit('setLoading', false);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
          commit('setLoading', false);
        });
    },

    inputQuery({ commit, state, dispatch }, query) {
      commit('setSearchQuery', query);
      commit('setCurrentPage', 1);
      clearTimeout(state.timeout);
      state.timeout = setTimeout(() => {
        dispatch('fetchPublicProfiles', 1);
      }, 500);
    },

    updateQueryAndFilter({ commit, dispatch }, query) {
      commit('setSearchQuery', query);

      commit('setCurrentPage', 1);
      dispatch('fetchPublicProfiles', 1);
    },

    setCurrentPage({ commit }, page) {
      commit('setCurrentPage', page);
    },

    setActiveProfile({ commit }, name) {
      commit('setActiveProfile', name);
    },

    setIsVendor({ commit }, bool) {
      commit('setIsVendor', bool);
    },
  },

  modules: {
    detail,
  },
};
